var tbITBSetup = null, tvITBSetup = null, cmNone = null, cmITBSetupItem = null, newItemCounter = -1, fCounter = 0;
var tbITBSetupChoices = null, gridITBSetupChoices = null;
var gridGroupList = null, tbFieldList = null, gridFieldList = null, newFieldCounter = 0, itemColorBackground = null,
	itemColorForeground = null, setupItemDeleteList = [];
var itbSetupValid = false, gridITBTemplates = null, tempITBSetupNodes = null;

function PJQITBSetupInitialize(response) {
	PJQ.templating.TemplateRenderer.renderTemplate(false, new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALLADMIN, 'ITBSetup', {
		isOldModule: true,
		isJsRender: true
	}), $('#tabITBSetup'), null, function () {
		jQuery("#itb-setup-itemtype-required,#itb-setup-itemtype-hidden,#itb-setup-itemtype-bidamount").change(function () {
			if (jQuery(this).prop('checked')) {
				switch (jQuery(this).attr('id')) {
					case "itb-setup-itemtype-required":
						jQuery('#itb-setup-itemtype-hidden').prop('checked', false);
						break;
					case "itb-setup-itemtype-bidamount":
						jQuery('#itb-setup-itemtype-hidden,#itb-setup-itemtype-bidamount-project').prop('checked', false);
						break;
					case "itb-setup-itemtype-bidamount-project":
						jQuery('#itb-setup-itemtype-hidden,#itb-setup-itemtype-bidamount').prop('checked', false);
						break;
					case "itb-setup-itemtype-hidden":
						jQuery('#itb-setup-itemtype-required,#itb-setup-itemtype-bidamount,#itb-setup-itemtype-bidamount-project').prop('checked', false);
						break;
				}
			}
		});

		jQuery('#itb-setup-itemtype-fieldtype').change(function () {
			if (jQuery('#itb-setup-itemtype-fieldtype').val() == 'CHOICE')
				jQuery('td.setup-itemtype-choices').show();
			else
				jQuery('td.setup-itemtype-choices').hide();
		});

		tbITBSetup = new dhtmlXToolbarObject("tb-itb-setup");
		tbITBSetup.setSkin("dhx_web");
		tbITBSetup.setIconsPath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxToolbar/imgs/");
		tbITBSetup.addButton("new", 1, "New Root Item", "add_page.gif", "add_pageD.gif");
		tbITBSetup.addSeparator("sep1", 2);
		tbITBSetup.addButton("edit", 3, "Edit Item", "edit.jpg", "editD.jpg");
		tbITBSetup.addSeparator("sep2", 4);
		tbITBSetup.addButton("delete", 5, "Delete Item", "action_delete.gif", "action_deleteD.gif");
		tbITBSetup.addSeparator("sep3", 6);
		tbITBSetup.addButton("manage-groups", 7, "Manage " + settings.GroupLabel, "groupFolderClosed.gif", "groupFolderClosedD.gif");
		//tbITBSetup.addSeparator("sep3", 8);
		//tbITBSetup.addButton("manage-fields", 9, "Manage Fields", "Group.gif", "GroupD.gif");
		tbITBSetup.addSpacer('manage-groups');
		tbITBSetup.addSeparator("sep4", 10);
		tbITBSetup.addButton("create-formula", 11, "Create Formula", "Group.gif", "GroupD.gif");
		tbITBSetup.addSeparator("sep5", 11);
		tbITBSetup.addButton("export", 12, "Export XLS", "excel.jpg", "exceld.jpg");

		tbITBSetup.attachEvent("onClick", tbITBSetupClick);

		tvITBSetup = new dhtmlXGridObject('tv-itb-setup');
		tvITBSetup.imgURL = "/DesktopModules/PanteraModuleGlobal/dhtmlx/3/6/dhtmlxGrid/imgs/scopes/";
		tvITBSetup.setHeader("&nbsp;,Name,Contacts,Notes,Misc,Field Type,Value/Formula,F#");
		tvITBSetup.setInitWidthsP("4,*,15,23,12,10,10,4");
		tvITBSetup.setColAlign("center,left,left,left,left,left,left,left");
		tvITBSetup.setColTypes("ch,tree,ro,ro,ro,coro,ed,ro");
		tvITBSetup.setColSorting("na,na,na,na,na,na,na,na");
		tvITBSetup.enableMultiline(true);
		tvITBSetup.enableTreeCellEdit(false);
		tvITBSetup.enableAutoHeight(true);
		tvITBSetup.enableDragAndDrop(true);
		tvITBSetup.setDragBehavior('complex-next');

		tvITBSetup.attachEvent("onDragIn", function (dId, lId, sObject, tObject) {

			// if the current selection is a group, or contains children that are groups, perform logic checks.

			tempITBSetupNodes = [];
			FindDescendantGroupNodes(dId);
			var nodesD = tempITBSetupNodes;
			tempITBSetupNodes = [];
			FindDescendantGroupNodes(lId);
			var nodesL = tempITBSetupNodes;

			// if the current selection IS a group
			if (tvITBSetup.getUserData(dId, 'GroupId')) {

				// there cannot be ancestors or descendants of the target that have groups.
				if (nodesL.length > 0 ||
					FindAncestorGroupNodes(lId).length > 0)
					return false;
			}
			else if (FindCurrentGroupNodes(dId).length > 0 || nodesD.length > 0) { // if the selection CONTAINS groups at any child level


				// there cannot be ancestors of the target that have groups.
				// there cannot be descendants
				// the current level of the target cannot have gruops??

				if (nodesL.length > 0 ||
					FindAncestorGroupNodes(lId).length > 0 ||
					FindCurrentGroupNodes(lId).length > 0)
					return false;

			}

			// if the target is a Field, the selection cannot contain a Group
			return true;
		});

		tvITBSetup.attachEvent("onDrop", function (sId, tId, dId, sObj, tObj, sCol, tCol) {
			EnableSaveP();
		});

		tvITBSetup.init();
		var combo = tvITBSetup.getCombo(5);
		combo.put('MONEY', 'Money');
		combo.put('INT', 'Integer');
		combo.put('DECIMAL', 'Decimal');
		combo.put('BOOL', 'Yes/No');
		combo.put('CHOICE', 'Single Choice');
		combo.put('CHOICEM', 'Multi Choice');
		combo.put('TEXT', 'Text');
		combo.put('FORMULA', 'Formula');

		tvITBSetup.setSkin("dhx_skyblue");
		//tvITBSetup.addRow('-1', '0,No Items...', null, 0, 'empty.png');
		//tvITBSetup.isEditable = false;

		cmNone = new dhtmlXMenuObject();
		cmNone.setIconsPath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxMenu/imgs/");
		cmNone.renderAsContextMenu();
		tvITBSetup.enableContextMenu(cmNone);

		cmITBSetupItem = new dhtmlXMenuObject();
		cmITBSetupItem.setIconsPath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxMenu/imgs/");
		cmITBSetupItem.addNewChild(cmITBSetupItem.topId, 1, "new", "New Item", false, "add_page.gif");
		cmITBSetupItem.addNewChild(cmITBSetupItem.topId, 2, "edit", "Edit Item", false, "edit.jpg");
		cmITBSetupItem.addNewChild(cmITBSetupItem.topId, 3, "delete", "Delete Item", false, "action_delete.gif");
		cmITBSetupItem.addNewChild(cmITBSetupItem.topId, 4, "manage-groups", "Manage " + settings.GroupLabel, false, "Group.gif");
		//cmITBSetupItem.addNewChild(cmITBSetupItem.topId, 5, "manage-fields", "Manage Fields", false, "Group.gif");
		cmITBSetupItem.attachEvent("onClick", function (id, zoneId, casState) {
			tbITBSetupClick(id, true);
		});


		cmITBSetupItem.renderAsContextMenu();

		tvITBSetup.attachEvent("onRowSelect", function (id, ind) {
			tbITBSetupRefresh();
		});

		tvITBSetup.attachEvent("onEditCell", function (stage, rId, cInd, nValue, oValue) {
			if (stage == 0) {
				if (rId == -1)
					return false;
			}
			return true;
		});

		tvITBSetup.attachEvent("onCheck", function (rId, cInd, state) {
			tbITBSetupRefresh();
		});

		tvITBSetup.attachEvent("onRowDblClicked", function (rId, cInd) {
			//if (cInd == 1 || cInd == 2 || cInd == 3 || cInd == 4) {
			EditITBSetupItem(rId);
			//}
		});

		tvITBSetup.attachEvent("onBeforeContextMenu", function (id, ind, obj) {
			tvITBSetup.setSelectedRow(id);

			if (id == -1)
				tvITBSetup.enableContextMenu(cmNone);
			else {
				tvITBSetup.enableContextMenu(cmITBSetupItem);

				var disableManageGroups = false;
				var disableNew = false;

				tempITBSetupNodes = [];
				FindDescendantGroupNodes(id);

				if (tvITBSetup.getUserData(id, 'GroupId'))
					disableManageGroups = true;
				else if (tempITBSetupNodes.length > 0 ||
					FindAncestorGroupNodes(id).length > 0)
					disableManageGroups = true;
				else if (tvITBSetup.cells(id, 5).getValue()) {
					disableManageGroups = true;
					disableNew = true;
				}

				if (disableManageGroups)
					cmITBSetupItem.setItemDisabled('manage-groups');
				else
					cmITBSetupItem.setItemEnabled('manage-groups');

				if (disableNew)
					cmITBSetupItem.setItemDisabled('new');
				else
					cmITBSetupItem.setItemEnabled('new');
			}

			return true;
		});

		tbITBSetupRefresh();
		tvITBSetup.loadXML('/DesktopModules/PJQProjectWallAdmin/GetITBSetup.aspx?sessionid=' + pjqSessionId + '&x=' + (new Date).getTime(), tvITBSetupAfterLoad);


		tbITBSetupChoices = new dhtmlXToolbarObject("tb-setup-itemtype-choices");
		tbITBSetupChoices.setSkin("dhx_web");
		tbITBSetupChoices.setIconsPath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxToolbar/imgs/");
		tbITBSetupChoices.addButton("new", 1, "New Choice", "add_page.gif", "add_pageD.gif");
		tbITBSetupChoices.addSeparator("sep1", 2);
		tbITBSetupChoices.addButton("delete", 5, "Delete Choice", "action_delete.gif", "action_deleteD.gif");
		tbITBSetupChoices.disableItem("delete");
		tbITBSetupChoices.attachEvent("onClick", tbITBSetupChoicesClick);

		gridITBSetupChoices = new dhtmlXGridObject('grid-setup-itemtype-choices');
		gridITBSetupChoices.setImagePath('/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxgrid/imgs/'); //path to images required by grid
		gridITBSetupChoices.enableMultiline(true);
		gridITBSetupChoices.setSkin(pjqGridTheme);
		gridITBSetupChoices.setHeader("Choices");
		gridITBSetupChoices.setInitWidthsP("100");
		gridITBSetupChoices.setColAlign("left");
		gridITBSetupChoices.setColTypes("ed");
		gridITBSetupChoices.setColSorting("na");
		gridITBSetupChoices.enableTooltips("false");
		gridITBSetupChoices.enableDragAndDrop(true);
		gridITBSetupChoices.enableAutoHeight(true, 200);
		gridITBSetupChoices.enableAutoWidth(true);
		gridITBSetupChoices.init();
		gridITBSetupChoices.attachEvent("onRowSelect", function (id, ind) {
			tbITBSetupChoices.enableItem("delete");
		});
	});
}

function tbITBSetupChoicesClick(id) {
	if (id == 'new') {
		var number = (new Date).getTime();
		gridITBSetupChoices.addRow(number, "");
		gridITBSetupChoices.selectCell(gridITBSetupChoices.getRowIndex(number), 0);
		setTimeout(function () {
			gridITBSetupChoices.editCell();
			gridITBSetupChoices.setSizes();
		}, 200);


	}
	else if (id == 'delete') {
		gridITBSetupChoices.deleteRow(gridITBSetupChoices.getSelectedRowId());
		tbITBSetupChoices.disableItem("delete");

	}
}

function tbITBSetupClick(id, isContextMenu) {
	if (id == 'new') {
		jQuery('#itb-setup-itemtype-label').val('');
		jQuery('#itb-setup-itemtype-label').prop('disabled', false);
		jQuery('#itb-setup-itemtype-notes').val('');
		var optionList = '<option value="">Select...</option>';
		for (var i = 0; i < settings.CompanyUsers.length; i++) {
			optionList = optionList + "<option value='" + settings.CompanyUsers[i].UserId.toString() + "'>" + settings.CompanyUsers[i].ContactName + "</option>";
		}
		jQuery('#itb-setup-itemtype-contact1 option').remove();
		jQuery('#itb-setup-itemtype-contact1').append(optionList).val('');
		jQuery('#itb-setup-itemtype-contact2 option').remove();
		jQuery('#itb-setup-itemtype-contact2').append(optionList).val('');
		jQuery('#itb-setup-itemtype-hidden').prop('checked', false);
		jQuery('#itb-setup-itemtype-required').prop('checked', false);
		jQuery('#itb-setup-itemtype-bidamount').prop('checked', false);
		jQuery('#itb-setup-itemtype-bidamount-project').prop('checked', false);

		jQuery('#itb-setup-itemtype-textcolor').css('color', '#000000');
		jQuery('#itb-setup-itemtype-forecolor').val('#000000');
		jQuery('#itb-setup-itemtype-textcolor').css('background-color', '#FFFFFF');
		jQuery('#itb-setup-itemtype-backcolor').val('#FFFFFF');

		itemColorBackground = new dhtmlXColorPicker({
			parent: "itb-setup-colorpicker-backcolor",
			input: "itb-setup-itemtype-backcolor-btn",
			target_value: "itb-setup-itemtype-backcolor",
			hide: true,
			color: '#FFFFFF'
		});
		itemColorBackground.attachEvent("onSelect", function (color, node) {
			jQuery('#itb-setup-itemtype-textcolor').css('background-color', color);
			jQuery('#itb-setup-itemtype-backcolor').val(color);

		});
		itemColorBackground.init();

		itemColorForeground = new dhtmlXColorPicker({
			parent: "itb-setup-colorpicker-forecolor",
			input: "itb-setup-itemtype-forecolor-btn",
			target_value: "itb-setup-itemtype-forecolor",
			hide: true,
			color: '#000000'
		});
		itemColorForeground.attachEvent("onSelect", function (color, node) {
			jQuery('#itb-setup-itemtype-textcolor').css('color', color);
			jQuery('#itb-setup-itemtype-forecolor').val(color);

		});

		jQuery('#itb-setup-itemtype-fieldtype').val('');
		jQuery('#itb-setup-itemtype-defaultvalue').val('');

		gridITBSetupChoices.clearAll();
		tbITBSetupChoices.disableItem("delete");

		/*
		myColorPicker.attachEvent(function(color){
			if (color != '#000000') {
				
			}
		});
		*/

		jQuery('td.setup-itemtype-choices').hide();

		itemColorForeground.init();

		var dlg = jQuery('#itb-setup-item').dialog({
			resizable: false,
			movable: true,
			height: 460,
			width: 650,
			title: 'New Item - F' + (fCounter + 1),
			modal: true,
			buttons: {
				"Save": function () {
					if (!validator.element('#itb-setup-itemtype-label'))
						return;

					EnableSaveP();
					tvITBSetup.isEditable = true;
					newItemCounter--;
					fCounter++;
					if (tvITBSetup.doesRowExist('-1'))
						tvITBSetup.deleteRow('-1');

					var selectedId = tvITBSetup.getSelectedRowId();
					if (!selectedId || !isContextMenu)
						selectedId = 0;

					tvITBSetup.addRow(newItemCounter.toString(), '0,' + jQuery('#itb-setup-itemtype-label').val() + ',,' + jQuery('#itb-setup-itemtype-notes').val(), null, selectedId, 'empty.png');

					var contactList = '';
					if (jQuery('#itb-setup-itemtype-contact1 option:selected').text() != 'Select...')
						contactList = jQuery('#itb-setup-itemtype-contact1 option:selected').text();
					if (jQuery('#itb-setup-itemtype-contact2 option:selected').text() != 'Select...') {
						if (contactList.length > 0)
							contactList += '<br />';
						contactList += jQuery('#itb-setup-itemtype-contact2 option:selected').text();
					}
					tvITBSetup.cells(newItemCounter.toString(), 2).setValue(contactList);
					tvITBSetup.setUserData(newItemCounter.toString(), 'UserId', jQuery('#itb-setup-itemtype-contact1').val());
					tvITBSetup.setUserData(newItemCounter.toString(), 'User2Id', jQuery('#itb-setup-itemtype-contact2').val());
					tvITBSetup.setUserData(newItemCounter.toString(), 'IsHidden', jQuery('#itb-setup-itemtype-hidden').prop('checked') ? 'true' : 'false');

					var misc = [];
					if (jQuery('#itb-setup-itemtype-hidden').prop('checked'))
						misc.push('Hidden');
					if (jQuery('#itb-setup-itemtype-required').prop('checked'))
						misc.push('Required');
					if (jQuery('#itb-setup-itemtype-bidamount').prop('checked'))
						misc.push('Bid Amt.');
					if (jQuery('#itb-setup-itemtype-bidamount-project').prop('checked'))
						misc.push('Project Bid Amt.');

					tvITBSetup.cells(newItemCounter.toString(), 4).setValue(misc.join(' '));

					tvITBSetup.setUserData(newItemCounter.toString(), 'IsHidden', jQuery('#itb-setup-itemtype-hidden').prop('checked') ? 'true' : 'false');
					tvITBSetup.setUserData(newItemCounter.toString(), 'IsRequired', jQuery('#itb-setup-itemtype-required').prop('checked') ? 'true' : 'false');
					tvITBSetup.setUserData(newItemCounter.toString(), 'IsBidAmount', jQuery('#itb-setup-itemtype-bidamount').prop('checked') ? 'true' : 'false');
					tvITBSetup.setUserData(newItemCounter.toString(), 'IsProjectBidAmount', jQuery('#itb-setup-itemtype-bidamount-project').prop('checked') ? 'true' : 'false');
					tvITBSetup.setUserData(newItemCounter.toString(), 'TextColor', jQuery('#itb-setup-itemtype-forecolor').val());
					tvITBSetup.setUserData(newItemCounter.toString(), 'BackgroundColor', jQuery('#itb-setup-itemtype-backcolor').val());
					tvITBSetup.cells(newItemCounter.toString(), 5).setValue(jQuery('#itb-setup-itemtype-fieldtype').val());
					tvITBSetup.cells(newItemCounter.toString(), 6).setValue(jQuery('#itb-setup-itemtype-defaultvalue').val());

					if (jQuery('#itb-setup-itemtype-fieldtype').val() == 'CHOICE') {
						var choices = [];
						gridITBSetupChoices.forEachRow(function (id) {
							choices.push(gridITBSetupChoices.cells(id, 0).getValue());
						});
						tvITBSetup.setUserData(newItemCounter.toString(), 'ChoiceList', choices.join('|'));
					}
					else
						tvITBSetup.setUserData(newItemCounter.toString(), 'ChoiceList', '');

					tvITBSetup.cells(newItemCounter.toString(), 7).setValue(fCounter);

					tvITBSetup.setSelectedRow(newItemCounter.toString());
					tvITBSetup.openItem(newItemCounter.toString());
					tvITBSetup.setSizes();
					tbITBSetupRefresh();

					jQuery(this).dialog("close");
				},
				"Cancel": function () {
					jQuery(this).dialog("close");
				}
			}
		});
		dlg.parent().appendTo($("Form[name='Form']"));

	}
	else if (id == 'edit') {
		EditITBSetupItem(tvITBSetup.getSelectedRowId());

	}
	else if (id == 'manage-groups') {
		ShowBusy('Loading...');
		gridGroupList = new dhtmlXGridObject('itb-setup-groups-grid');
		gridGroupList.setImagePath('/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxgrid/imgs/'); //path to images required by grid
		gridGroupList.enableMultiline(true);
		gridGroupList.setSkin(pjqGridTheme);
		gridGroupList.setHeader("&nbsp;," + settings.GroupLabel + ",Contacts");
		gridGroupList.setInitWidthsP("6,80,14");
		gridGroupList.setColAlign("center,left,center");
		gridGroupList.setColTypes("ch,ro,ro");
		gridGroupList.setColSorting("na,na,na");
		gridGroupList.enableTooltips("false,true,false");
		gridGroupList.enableAutoHeight(true, 460);
		gridGroupList.enableAutoWidth(true);
		gridGroupList.init();
		gridGroupList.loadXML('/DesktopModules/PJQProjectWallAdmin/GetGroupList.aspx?sessionid=' + pjqSessionId + '&x=' + (new Date).getTime(), function () {
			var selectedId = tvITBSetup.getSelectedRowId();
			var subItems = tvITBSetup.getAllSubItems(selectedId).split(',');
			if (subItems.length == 1 && !subItems[0])
				subItems = [];

			gridGroupList.forEachRow(function (id) {
				for (var i = 0; i < subItems.length; i++) {
					if (tvITBSetup.getUserData(subItems[i], 'GroupId') == id)
						gridGroupList.cells(id, 0).setChecked(true);
				}
			});
			HideBusy();
			jQuery('#itb-setup-groups').dialog({
				resizable: false,
				movable: true,
				height: 620,
				width: 650,
				title: 'Manage ' + settings.GroupLabel,
				modal: true,
				buttons: {
					"Save": function () {
						var selectedId = tvITBSetup.getSelectedRowId();
						var subItems = tvITBSetup.getAllSubItems(selectedId).split(',');
						if (subItems.length == 1 && !subItems[0])
							subItems = [];
						var existingGroupCount = 0;
						for (var i = 0; i < subItems.length; i++) {
							if (tvITBSetup.getUserData(subItems[i], 'GroupId'))
								existingGroupCount++;
						}
						gridGroupList.forEachRow(function (id) {
							if (!gridGroupList.cells(id, 0).isChecked()) {
								for (var i = 0; i < subItems.length; i++) {
									if (tvITBSetup.getUserData(subItems[i], 'GroupId') == id) {
										tvITBSetup.deleteRow(subItems[i]);
										setupItemDeleteList.push(subItems[i]);
										EnableSaveP(true);
										tbITBSetupRefresh();
									}
								}
							}
						});

						var lastGroupId = '';
						var selectedRows = gridGroupList.getCheckedRows(0).split(',');
						var selectedRowIndex = 0;

						//gridGroupList.forEachRow(function(id) {
						var k = 0;
						for (selectedRowIndex = 0; selectedRowIndex < selectedRows.length; selectedRowIndex++) {
							var id = selectedRows[selectedRowIndex];

							var foundGroupId = '';

							if (gridGroupList.cells(id, 0).isChecked()) {
								subItems = tvITBSetup.getAllSubItems(selectedId).split(',');
								if (subItems.length == 1 && !subItems[0])
									subItems = [];

								for (var i = 0; i < subItems.length; i++) {
									if (tvITBSetup.getUserData(subItems[i], 'GroupId') == id)
										foundGroupId = subItems[i];
								}

								if (!foundGroupId) {
									EnableSaveP();
									newItemCounter--;
									fCounter++;


									if (subItems.length == 0 && existingGroupCount == 0) {
										// there are no items at all, so just add it to the parent
										tvITBSetup.addRow(newItemCounter.toString(), '0,' + gridGroupList.cells(id, 1).getValue(), null, selectedId, "groupFolderClosed.gif");
									}
									else if (subItems.length > 0 && existingGroupCount == 0) {
										tvITBSetup.addRowBefore(newItemCounter.toString(), '0,' + gridGroupList.cells(id, 1).getValue(), subItems[0], "groupFolderClosed.gif");
									}
									else if (lastGroupId) {
										// figure out the row to add after
										for (var i = 0; i < subItems.length; i++) {
											if (tvITBSetup.getUserData(subItems[i], 'GroupId') == selectedRows[selectedRowIndex - 1])
												foundGroupId = subItems[i];
										}
										tvITBSetup.addRowAfter(newItemCounter.toString(), '0,' + gridGroupList.cells(id, 1).getValue(), foundGroupId, "groupFolderClosed.gif");

									}
									else {
										tvITBSetup.addRowBefore(newItemCounter.toString(), '0,' + gridGroupList.cells(id, 1).getValue(), subItems[0], "groupFolderClosed.gif");
									}


									tvITBSetup.setUserData(newItemCounter.toString(), 'ItemType', 'GROUP');
									tvITBSetup.setUserData(newItemCounter.toString(), 'GroupId', id);
									tvITBSetup.setUserData(newItemCounter.toString(), 'IsHidden', jQuery('#itb-setup-groups-grid-hidden').prop('checked') ? 'true' : 'false');
									if (jQuery('#itb-setup-groups-grid-hidden').prop('checked'))
										tvITBSetup.cells(newItemCounter.toString(), 4).setValue('Hidden');

									tvITBSetup.setUserData(newItemCounter.toString(), 'IsRequired', 'false');
									tvITBSetup.setUserData(newItemCounter.toString(), 'IsBidAmount', 'false');
									tvITBSetup.setUserData(newItemCounter.toString(), 'IsProjectBidAmount', 'false');
									tvITBSetup.setUserData(newItemCounter.toString(), 'TextColor', '#000000');
									tvITBSetup.setUserData(newItemCounter.toString(), 'BackgroundColor', '#FFFFFF');
									tvITBSetup.setUserData(newItemCounter.toString(), 'ChoiceList', '');

									tvITBSetup.cells(newItemCounter.toString(), 7).setValue(fCounter);

									existingGroupCount++;

								}
								lastGroupId = id;
							}
						}
						//});
						tvITBSetup.openItem(selectedId);
						jQuery(this).dialog("close");
					},
					"Cancel": function () {
						jQuery(this).dialog("close");
					}
				}
			});

		});

	}
	else if (id == 'create-formula') {
		jQuery('#itb-setup-itemtype-formula-add').prop('checked', true);
		GenerateFormula();
		jQuery('#itb-setup-formula').dialog({
			resizable: false,
			movable: true,
			height: 400,
			width: 450,
			title: 'Create Formula',
			modal: true,
			buttons: {
				"Close": function () {
					jQuery(this).dialog("close");
				}
			}
		});

	}
	else if (id == 'delete') {
		var mesg = 'Are you sure you want to delete this item';
		if (tvITBSetup.getSubItems(tvITBSetup.getSelectedRowId()).length > 0)
			mesg += ' and all of its children';
		showInfoDialogPWall('Delete Item', mesg + '?', 'ui-icon-question', 'delete-itb-setup-item');

	}
	else if (id == 'export') {
		tvITBSetup.setSerializationLevel(true, false, false, false, false, true);
		var xml = tvITBSetup.serialize();
		var xmlFile = '/DesktopModules/PJQProjectWallAdmin/ExportITBSetup.aspx?sessionid=' + pjqSessionId + '&x=' + (new Date).getTime();
		var myData = {gridXML: xml};

		jQuery.ajax({
			type: "POST",
			url: xmlFile,
			data: myData,
			dataType: "text",
			success: function (result) {
				showInfoDialogPWall('Export Complete', '<a href="' + result + '">Click here to download your export.</a>', 'ui-icon-info');

			},
			error: function (xhr, status, error) {
				showInfoDialogPWall('Save Error', "An error occurred while saving setup: " + error, 'ui-icon-alert');
			}
		});
	}


}

function GenerateFormula() {
	var symbol = '+';
	if (jQuery('#itb-setup-itemtype-formula-subtract').prop('checked'))
		symbol = '-';
	if (jQuery('#itb-setup-itemtype-formula-multiply').prop('checked'))
		symbol = '*';
	if (jQuery('#itb-setup-itemtype-formula-divide').prop('checked'))
		symbol = '/';

	var tokens = [];
	var rowId;
	var items = tvITBSetup.getCheckedRows(0).split(',');
	for (var i = 0; i < items.length; i++) {
		tokens.push('F' + tvITBSetup.cells(items[i], 7).getValue());
	}
	jQuery('#itb-setup-itemtype-formula').val(tokens.join(symbol)).focus();
}

function tvITBSetupAfterLoad() {
	tvITBSetup.forEachRow(function (id) {
		if (parseInt(tvITBSetup.cells(id, 7).getValue()) > fCounter)
			fCounter = parseInt(tvITBSetup.cells(id, 7).getValue());
	});

	jQuery('#tb-itb-setup-loading').hide();
	tbITBSetupRefresh();
}

function tbITBSetupRefresh() {
	var selectedId = tvITBSetup.getSelectedRowId();
	tbITBSetup.disableItem('edit');
	tbITBSetup.disableItem('delete');
	tbITBSetup.disableItem('manage-groups');
	tbITBSetup.disableItem('create-formula');
	tbITBSetup.disableItem('export');

	if (tvITBSetup.getRowsNum() > 0) {
		tbITBSetup.enableItem('export');
		jQuery('#itb-setup-template').button('option', 'label', 'Save Template');
	}
	else
		jQuery('#itb-setup-template').button('option', 'label', 'Load Template');

	if (tvITBSetup.getCheckedRows(0))
		tbITBSetup.enableItem('create-formula');

	if (selectedId && selectedId != '-1') {
		tbITBSetup.enableItem('delete');
		tbITBSetup.enableItem('edit');
		if (tvITBSetup.getUserData(selectedId, 'ItemType') != 'GROUP') {
			tbITBSetup.enableItem('manage-groups');
		}
	}
}

function DialogSaveOnEnter(e, buttonIndex) {
	var charCode = (typeof e.which === "number") ? e.which : e.keyCode;
	if (charCode == 13) {
		//jQuery('div.ui-dialog-buttonset button')[buttonIndex].click();	
		e.preventDefault();
		e.stopPropagation();
		return false;
	}

	return true;
}

function EditITBSetupItem(selectedId) {
	jQuery('#itb-setup-itemtype-label').val(tvITBSetup.cells(selectedId, 1).getValue());
	jQuery('#itb-setup-itemtype-label').prop('disabled', false);
	jQuery('#itb-setup-itemtype-notes').val(tvITBSetup.cells(selectedId, 3).getValue());
	var optionList = '<option value="">Select...</option>';
	for (var i = 0; i < settings.CompanyUsers.length; i++) {
		optionList = optionList + "<option value='" + settings.CompanyUsers[i].UserId.toString() + "'>" + settings.CompanyUsers[i].ContactName + "</option>";
	}
	jQuery('#itb-setup-itemtype-contact1 option').remove();
	jQuery('#itb-setup-itemtype-contact1').append(optionList).val(tvITBSetup.getUserData(selectedId, 'UserId'));
	jQuery('#itb-setup-itemtype-contact2 option').remove();
	jQuery('#itb-setup-itemtype-contact2').append(optionList).val(tvITBSetup.getUserData(selectedId, 'User2Id'));
	jQuery('#itb-setup-itemtype-hidden').prop('checked', (tvITBSetup.getUserData(selectedId, 'IsHidden') == 'true'));
	jQuery('#itb-setup-itemtype-required').prop('checked', (tvITBSetup.getUserData(selectedId, 'IsRequired') == 'true'));
	jQuery('#itb-setup-itemtype-bidamount').prop('checked', (tvITBSetup.getUserData(selectedId, 'IsBidAmount') == 'true'));
	jQuery('#itb-setup-itemtype-bidamount-project').prop('checked', (tvITBSetup.getUserData(selectedId, 'IsProjectBidAmount') == 'true'));

	var foreColor = tvITBSetup.getUserData(selectedId, 'TextColor');
	if (!foreColor)
		foreColor = '#000000';

	var backColor = tvITBSetup.getUserData(selectedId, 'BackgroundColor');
	if (!backColor)
		backColor = '#FFFFFF';

	jQuery('#itb-setup-itemtype-textcolor').css('color', foreColor);
	jQuery('#itb-setup-itemtype-forecolor').val(foreColor);
	jQuery('#itb-setup-itemtype-textcolor').css('background-color', backColor);
	jQuery('#itb-setup-itemtype-backcolor').val(backColor);

	itemColorBackground = new dhtmlXColorPicker({
		parent: "itb-setup-colorpicker-backcolor",
		input: "itb-setup-itemtype-backcolor-btn",
		target_value: "itb-setup-itemtype-backcolor",
		hide: true,
		color: backColor
	});
	itemColorBackground.init();
	itemColorBackground.attachEvent("onSelect", function (color, node) {
		jQuery('#itb-setup-itemtype-textcolor').css('background-color', color);
		jQuery('#itb-setup-itemtype-backcolor').val(color);
	});

	itemColorForeground = new dhtmlXColorPicker({
		parent: "itb-setup-colorpicker-forecolor",
		input: "itb-setup-itemtype-forecolor-btn",
		target_value: "itb-setup-itemtype-forecolor",
		hide: true,
		color: foreColor
	});
	itemColorForeground.init();
	itemColorForeground.attachEvent("onSelect", function (color, node) {
		jQuery('#itb-setup-itemtype-textcolor').css('color', color);
		jQuery('#itb-setup-itemtype-forecolor').val(color);

	});

	jQuery('#itb-setup-itemtype-fieldtype').val(tvITBSetup.cells(selectedId, 5).getValue());
	jQuery('#itb-setup-itemtype-defaultvalue').val(tvITBSetup.cells(selectedId, 6).getValue());
	jQuery('td.setup-itemtype-choices').hide();
	gridITBSetupChoices.clearAll();
	if (jQuery('#itb-setup-itemtype-fieldtype').val() == 'CHOICE') {
		jQuery('td.setup-itemtype-choices').show();

		var choices = tvITBSetup.getUserData(selectedId, 'ChoiceList').split('|');
		for (var j = 0; j < choices.length; j++) {
			gridITBSetupChoices.addRow(j + 1, choices[j]);
		}
	}

	tbITBSetupChoices.disableItem("delete");

	var dlg = jQuery('#itb-setup-item').dialog({
		resizable: false,
		movable: true,
		height: 460,
		width: 650,
		title: 'Edit Item - F' + tvITBSetup.cells(selectedId, 7).getValue(),
		modal: true,
		buttons: {
			"Save": function () {
				if (!validator.element('#itb-setup-itemtype-label'))
					return;

				EnableSaveP();

				tvITBSetup.cells(selectedId, 1).setValue(jQuery('#itb-setup-itemtype-label').val());

				var contactList = '';
				if (jQuery('#itb-setup-itemtype-contact1 option:selected').text() != 'Select...')
					contactList = jQuery('#itb-setup-itemtype-contact1 option:selected').text();
				if (jQuery('#itb-setup-itemtype-contact2 option:selected').text() != 'Select...') {
					if (contactList.length > 0)
						contactList += '<br />';
					contactList += jQuery('#itb-setup-itemtype-contact2 option:selected').text();
				}
				tvITBSetup.cells(selectedId, 2).setValue(contactList);
				tvITBSetup.setUserData(selectedId, 'UserId', jQuery('#itb-setup-itemtype-contact1').val());
				tvITBSetup.setUserData(selectedId, 'User2Id', jQuery('#itb-setup-itemtype-contact2').val());

				tvITBSetup.cells(selectedId, 3).setValue(jQuery('#itb-setup-itemtype-notes').val());

				var misc = [];
				if (jQuery('#itb-setup-itemtype-hidden').prop('checked'))
					misc.push('Hidden');
				if (jQuery('#itb-setup-itemtype-required').prop('checked'))
					misc.push('Required');
				if (jQuery('#itb-setup-itemtype-bidamount').prop('checked'))
					misc.push('Bid Amt.');
				if (jQuery('#itb-setup-itemtype-bidamount-project').prop('checked'))
					misc.push('Project Bid Amt.');

				tvITBSetup.cells(selectedId, 4).setValue(misc.join(' '));
				tvITBSetup.setUserData(selectedId, 'IsHidden', jQuery('#itb-setup-itemtype-hidden').prop('checked') ? 'true' : 'false');
				tvITBSetup.setUserData(selectedId, 'IsRequired', jQuery('#itb-setup-itemtype-required').prop('checked') ? 'true' : 'false');
				tvITBSetup.setUserData(selectedId, 'IsBidAmount', jQuery('#itb-setup-itemtype-bidamount').prop('checked') ? 'true' : 'false');
				tvITBSetup.setUserData(selectedId, 'IsProjectBidAmount', jQuery('#itb-setup-itemtype-bidamount-project').prop('checked') ? 'true' : 'false');
				tvITBSetup.setUserData(selectedId, 'TextColor', jQuery('#itb-setup-itemtype-forecolor').val());
				tvITBSetup.setUserData(selectedId, 'BackgroundColor', jQuery('#itb-setup-itemtype-backcolor').val());
				tvITBSetup.cells(selectedId, 5).setValue(jQuery('#itb-setup-itemtype-fieldtype').val());
				tvITBSetup.cells(selectedId, 6).setValue(jQuery('#itb-setup-itemtype-defaultvalue').val());


				if (jQuery('#itb-setup-itemtype-fieldtype').val() == 'CHOICE') {
					var choices = [];
					gridITBSetupChoices.forEachRow(function (id) {
						choices.push(gridITBSetupChoices.cells(id, 0).getValue());
					});
					tvITBSetup.setUserData(selectedId, 'ChoiceList', choices.join('|'));
				}
				else
					tvITBSetup.setUserData(selectedId, 'ChoiceList', '');

				tvITBSetup.setSizes();

				jQuery(this).dialog("close");
			},
			"Cancel": function () {
				jQuery(this).dialog("close");
			}
		}
	});
	dlg.parent().appendTo($("Form[name='Form']"));

}

function SaveITBSetup(templateId) {
	if (!ITBSetupValidate())
		return false;

	tvITBSetup.setSerializationLevel(true, false, false, false, false, true);
	var xml = tvITBSetup.serialize();
	var deleteITBSetupList = '';
	var xmlFile = '/DesktopModules/PJQProjectWallAdmin/SaveITBSetup.aspx?sessionid=' + pjqSessionId + '&x=' + (new Date).getTime();

	if (templateId)
		xmlFile += "&t=" + templateId;

	var deleteList = setupItemDeleteList.join(',');
	var myData = {gridXML: xml, deleteItems: deleteList};

	jQuery.ajax({
		type: "POST",
		url: xmlFile,
		data: myData,
		dataType: "xml",
		success: function (result) {
			tvITBSetup.clearAll();
			tvITBSetup.parse(result, tvITBSetupAfterLoad, "xml");
			tvITBSetupAfterLoad();
			DisableSave();
		},
		error: function (xhr, status, error) {
			showInfoDialogPWall('Save Error', "An error occurred while saving setup: " + error, 'ui-icon-alert');
		}
	});
}

function DeleteITBSetupItem() {
	var list = tvITBSetup.getAllSubItems(tvITBSetup.getSelectedRowId()).split(',');
	list.push(tvITBSetup.getSelectedRowId());

	for (var i = 0; i < list.length; i++) {
		if (parseInt(list[i]) > 0) {
			setupItemDeleteList.push(list[i]);
		}
	}

	tvITBSetup.deleteRow(tvITBSetup.getSelectedRowId());
	tbITBSetupRefresh();
	EnableSaveP();
}

function ReloadITBSetup() {
	tvITBSetup.clearAll();
	tvITBSetup.loadXML('/DesktopModules/PJQProjectWallAdmin/GetITBSetup.aspx?sessionid=' + pjqSessionId + '&x=' + (new Date).getTime(), tvITBSetupAfterLoad);
}

function FindCurrentGroupNodes(id) {
	var nodes = [];

	var items = tvITBSetup.getSubItems(id).split(',');
	for (var i = 0; i < items.length; i++) {
		if (items[i]) {
			if (tvITBSetup.getUserData(items[i], 'GroupId')) {
				if (jQuery.inArray(tvITBSetup.getParentId(items[i]), nodes) == -1)
					nodes.push(tvITBSetup.getParentId(items[i]));
			}
		}
	}

	return nodes;
}

function FindCurrentFieldNodes(id) {
	var nodes = [];

	var items = tvITBSetup.getSubItems(id).split(',');
	for (var i = 0; i < items.length; i++) {
		if (items[i]) {
			if (tvITBSetup.cells(items[i], 5).getValue()) {
				if (jQuery.inArray(tvITBSetup.getParentId(items[i]), nodes) == -1)
					nodes.push(tvITBSetup.getParentId(items[i]));
			}
		}
	}

	return nodes;
}

function FindAncestorGroupNodes(id) {
	var nodes = [];

	var parentId = tvITBSetup.getParentId(id);
	while (parentId) {
		var result = FindCurrentGroupNodes(parentId);
		if (result.length > 0)
			nodes.push(result[0]);

		parentId = tvITBSetup.getParentId(parentId);
	}

	return nodes;
}

function FindAncestorFieldNodes(id) {
	var nodes = [];

	var parentId = tvITBSetup.getParentId(id);
	while (parentId) {
		var result = FindCurrentFieldNodes(parentId);
		if (result.length > 0)
			nodes.push(result[0]);

		parentId = tvITBSetup.getParentId(parentId);
	}

	return nodes;
}

function FindDescendantGroupNodes(id) {

	var items = tvITBSetup.getAllSubItems(id).split(',');
	for (var i = 0; i < items.length; i++) {
		if (items[i]) {
			if (tvITBSetup.getUserData(items[i], 'GroupId')) {
				if (jQuery.inArray(tvITBSetup.getParentId(items[i]), tempITBSetupNodes) == -1 && tvITBSetup.getParentId(items[i]) != id)
					tempITBSetupNodes.push(tvITBSetup.getParentId(items[i]));
			}
		}
	}

}

function FindDescendantFieldNodes(id) {

	var items = tvITBSetup.getAllSubItems(id).split(',');
	for (var i = 0; i < items.length; i++) {
		if (items[i]) {
			if (tvITBSetup.cells(items[i], 5).getValue()) {
				if (jQuery.inArray(tvITBSetup.getParentId(items[i]), tempITBSetupNodes) == -1 && tvITBSetup.getParentId(items[i]) != id)
					tempITBSetupNodes.push(tvITBSetup.getParentId(items[i]));
			}
		}
	}
}

function ITBSetupValidate() {
	// check all Formula rows to be sure they contain valid references.
	itbSetupValid = true;

	tvITBSetup.forEachRow(function (id) {
		tvITBSetup.setCellTextStyle(id, 6, "color:black;");
		if (tvITBSetup.cells(id, 5).getValue() == 'FORMULA') {
			var formula = tvITBSetup.cells(id, 6).getValue().toUpperCase();
			var isBad = false;

			// parse out the F references and validate them
			var matches = formula.match(/F[0-9]+/ig);
			var i = 0;
			for (i = 0; i < matches.length; i++) {
				var fieldId = parseInt(matches[i].substring(1));
				if (!fieldId || !ITBSetupGetFieldNumberRowId(fieldId.toString())) {
					tvITBSetup.setCellTextStyle(id, 6, "color:red;");
					isBad = true;
					break;
				}
			}

			// find any other letter that isn't an F
			if (formula.match(/[a-e]/i) || formula.match(/[g-z]/i)) {
				tvITBSetup.setCellTextStyle(id, 6, "color:red;");
				isBad = true;
			}

			// if it still seems good, replace all the field numbers and attempt to eval it.
			try {
				for (i = 0; i < matches.length; i++) {
					formula = formula.replace(new RegExp(matches[i], 'g'), '1');
				}

				var test = eval(formula);

			} catch (err) {
				tvITBSetup.setCellTextStyle(id, 6, "color:red;");
				isBad = true;
			}
			if (isBad)
				itbSetupValid = false;
		}

	});
	return itbSetupValid;
}

function ITBSetupGetFieldNumberRowId(fieldNumber) {
	var rowId = null;
	tvITBSetup.forEachRow(function (id) {
		if (tvITBSetup.cells(id, 7).getValue() == fieldNumber)
			rowId = id;
	});

	return rowId;
}

function LoadTemplateDialog() {
	var isSave = true;
	var myTitle = 'Save Template';
	jQuery('td.itb-setup-templates-name').show();
	jQuery('#itb-setup-template-name').val(tvITBSetup.getUserData(null, 'TemplateName'));
	var myButtons = {
		"Save Template": function () {
			if (!validator.element('#itb-setup-template-name'))
				return;
			jQuery(this).dialog('close');
			var templateName = jQuery('#itb-setup-template-name').val().trim();
			var templateId = 1, i = 0;
			for (i = 0; i < gridITBTemplates.getRowsNum(); i++) {
				if (gridITBTemplates.cells2(i, 0).getValue() == templateName)
					templateId = gridITBTemplates.getRowId(i);
			}
			tvITBSetup.setUserData(null, 'TemplateName', templateName);
			SaveITBSetup(templateId);
		}
	};
	if (tvITBSetup.getRowsNum() == 0) {
		isSave = false;
		myTitle = 'Load Template';
		jQuery('td.itb-setup-templates-name').hide();
		myButtons = {
			"Load Template": function () {
				if (!gridITBTemplates.getSelectedRowId())
					return;

				tvITBSetup.clearAll();
				tbITBSetupRefresh();
				tvITBSetup.loadXML('/DesktopModules/PJQProjectWallAdmin/GetITBSetup.aspx?sessionid=' + pjqSessionId + '&t=' + gridITBTemplates.getSelectedRowId() + '&x=' + (new Date).getTime(), tvITBSetupAfterLoad);
				EnableSaveP();

				jQuery(this).dialog('close');
			}
		};
	}
	else {
		// make sure it is valid before allowing a save
		if (!ITBSetupValidate())
			return;
	}

	ShowBusy('Loading...');
	gridITBTemplates = new dhtmlXGridObject('grid-itb-setup-templates');
	gridITBTemplates.setImagePath('/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxgrid/imgs/'); //path to images required by grid
	gridITBTemplates.setSkin(pjqGridTheme);
	gridITBTemplates.setHeader('Template Name,Action');
	gridITBTemplates.setInitWidthsP("90,10");
	gridITBTemplates.setColAlign("left,center");
	gridITBTemplates.setColTypes("ro,ro");
	gridITBTemplates.setColSorting("na,na");
	gridITBTemplates.enableTooltips("false,false");
	gridITBTemplates.enableAutoHeight(true, 460);
	gridITBTemplates.enableAutoWidth(true);
	gridITBTemplates.init();
	gridITBTemplates.loadXML('/DesktopModules/PJQProjectWallAdmin/GetITBSetupTemplates.aspx?sessionid=' + pjqSessionId + '&x=' + (new Date).getTime(), function () {
		HideBusy();
		var dlg = jQuery('#itb-setup-templates').dialog({
			resizable: false,
			movable: true,
			height: 620,
			width: 650,
			title: myTitle,
			modal: true,
			buttons: myButtons
		});
		dlg.parent().appendTo($("Form[name='Form']"));
	});


}